module.exports = __webpack_public_path__ + "static/media/destination-doubleclick.15a3e2c4.png";